
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Input } from '@/components/ui/input';
import { Control } from 'react-hook-form';
import { FlightUpdateFormValues } from './schemas';

interface StatusUpdateFormProps {
  control: Control<FlightUpdateFormValues>;
}

export function StatusUpdateForm({ control }: StatusUpdateFormProps) {
  return (
    <>
      <FormField
        control={control}
        name="status"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Status</FormLabel>
            <Select onValueChange={field.onChange} value={field.value}>
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder="Select flight status" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value="Scheduled">Scheduled</SelectItem>
                <SelectItem value="Check-in Open">Check-in Open</SelectItem>
                <SelectItem value="Check-in Closed">Check-in Closed</SelectItem>
                <SelectItem value="Boarding Soon">Boarding Soon</SelectItem>
                <SelectItem value="Boarding">Boarding</SelectItem>
                <SelectItem value="Gate Closed">Gate Closed</SelectItem>
                <SelectItem value="On Time">On Time</SelectItem>
                <SelectItem value="Delayed">Delayed</SelectItem>
                <SelectItem value="Departed">Departed</SelectItem>
                <SelectItem value="In Air">In Air</SelectItem>
                <SelectItem value="Diverted">Diverted</SelectItem>
                <SelectItem value="Recovery">Recovery</SelectItem>
                <SelectItem value="Landed">Landed</SelectItem>
                <SelectItem value="Arrived">Arrived</SelectItem>
                <SelectItem value="Cancelled">Cancelled</SelectItem>
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={control}
        name="scheduled_departure"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Scheduled Departure (Optional)</FormLabel>
            <FormControl>
              <Input 
                type="datetime-local" 
                {...field}
                value={field.value || ''}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={control}
        name="scheduled_arrival"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Scheduled Arrival (Optional)</FormLabel>
            <FormControl>
              <Input 
                type="datetime-local" 
                {...field}
                value={field.value || ''}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={control}
        name="status_reason"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Status Reason (Optional)</FormLabel>
            <FormControl>
              <Input 
                placeholder="e.g., Weather delay, Mechanical issue" 
                {...field}
                value={field.value || ''}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
}
